import { Link } from 'react-router-dom';
import { Home } from 'lucide-react';
import { Breadcrumb } from '@ntconsult/aluma-react';
import type { BreadcrumbItem } from '@features/folders/types';

interface ExplorerBreadcrumbProps {
  items: BreadcrumbItem[] | undefined;
}

export function ExplorerBreadcrumb({ items }: ExplorerBreadcrumbProps) {
  const lastIndex = items ? items.length - 1 : -1;

  const hasIntermediate = lastIndex >= 1;

  return (
    <Breadcrumb className="mb-2">
      <Breadcrumb.List>
        <Breadcrumb.Item>
          <Breadcrumb.Link asChild>
            <Link to="/files">
              <Home className="w-4 h-4" aria-hidden="true" />
            </Link>
          </Breadcrumb.Link>
        </Breadcrumb.Item>
        {hasIntermediate && (
          <Breadcrumb.Item className="sm:hidden">
            <Breadcrumb.Separator />
            <Breadcrumb.Ellipsis />
          </Breadcrumb.Item>
        )}
        {items?.map((item, index) => {
          const isLast = index === lastIndex;
          const hideOnMobile = !isLast;
          return (
            <Breadcrumb.Item
              key={item.id}
              className={hideOnMobile ? 'hidden sm:flex' : 'max-w-[60vw] sm:max-w-none'}
            >
              <Breadcrumb.Separator className={hideOnMobile ? 'hidden sm:flex' : ''} />
              {isLast ? (
                <Breadcrumb.Page className="truncate">{item.name}</Breadcrumb.Page>
              ) : (
                <Breadcrumb.Link asChild>
                  <Link to={`/files/${item.id}`}>{item.name}</Link>
                </Breadcrumb.Link>
              )}
            </Breadcrumb.Item>
          );
        })}
      </Breadcrumb.List>
    </Breadcrumb>
  );
}
